<rotec-radio-row-v2
  [darkMode]="true"
  [options]="schedulingOptions"
  [spaceEvenly]="true"
  [selected]="model.single"
  (selectedChange)="changeSchedulingType($event)"
></rotec-radio-row-v2>

@if (model.single) {
  <div class="due-date">
    <h5 translate>Planned Execution Date</h5>
    <rotec-datepicker-v2
      [darkMode]="true"
      [min]="minDate"
      [value]="$any(model).dueDate"
      (valueChange)="changeDueDate($event)"
      (focusout)="touched()"
    ></rotec-datepicker-v2>
  </div>
}

@if (!model.single) {
  <ma-scheduling-interval
    (focusout)="touched()"
    [scheduling]="$any(model).scheduling"
    (schedulingChange)="changeScheduling($event)"
  ></ma-scheduling-interval>
}
